<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
}
html,body {
  margin: 0px;
  padding: 0px;
  /* background-color:#5d8688cc; */
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
}
ul,li{
    list-style: none;
  }
  
.Menu-Box {
  -webkit-tap-highlight-color:rgba(0,0,0,0);
  margin: 0 auto;
  padding-top: 50px;
  width: 1200px;
  z-index: 9999;
  left: 231px;
  right: 0;
  position: absolute;
}
.Menu-logo{
    float: left;
    width: 200px;
    height: 160px;
    /* margin-top: 16px; */
    margin-top: -17px;
    background-image: url('~@/assets/real_logo.png');
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: contain;
    margin-right: 20px;
    cursor: pointer;
    -webkit-transform: translateY(-26px);
    -ms-transform: translateY(-26px);
    transform: translateY(-26px);
  }
  .clearfix{
    zoom:1;
    margin-top: 68px;
  }
  .Menu-nav{
    float: left;
    color: #fff;
    font-size: 16px;
    line-height: 24px;
    width: 68px;
    text-align: center;
    margin: 0 38px;
    cursor: pointer;
  }
  .Menu-Box ul li:hover{
    color: orange;
  }
  .Menu_active{
    border-bottom: 3px solid #f5a623;
    color: #f5a623;
    font-weight: 700;
  }
  .connect_icon{
    /* background-color: chartreuse; */
    background-image: url('~@/assets/phone_logo_2.png');
    background-repeat: no-repeat;
    background-size: cover;
    height: 70px;
    width: 70px;
    position: absolute;
    z-index: 9999;
    right: 0;
    bottom: 35%;
  }
  .phone_number{
    /* background-color:#a08bb5d6; */
    background-color: #4e709ed6;
    /* height: 100px; */
    width: 150px;
    padding: 10px 25px;
    position: absolute;
    z-index: 8888;
    right: 65px;
    bottom: 1%;
    text-align: left ;
    color: white;
    font-size: 16px;
    font-weight: 700;
    text-decoration: none;
    border-radius:10px;
    box-shadow:0 0 9px 3px #7b7777;
    opacity:0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue